'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of order history mobile
 */ const OrderHistoryMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.9236",
                cy: "51.9941",
                rx: "51.9236",
                ry: "51.9941",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.9805",
                y: "68.6484",
                width: "17.5717",
                height: "5.22641",
                rx: "1.61817",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.4757 18.4707H62.9386C64.5704 18.4797 66.1327 19.134 67.285 20.291C68.4373 21.4479 69.0864 23.0139 69.0909 24.6478V78.5341C69.0864 80.171 68.4349 81.7395 67.2789 82.8969C66.1229 84.0544 64.5563 84.7066 62.9214 84.7112H40.4585C38.8237 84.7066 37.2571 84.0544 36.1011 82.8969C34.945 81.7395 34.2936 80.171 34.2891 78.5341V66.6819V59.0538V57.1803V24.6478C34.2936 23.0079 34.9474 21.4368 36.1071 20.2789C37.2669 19.1209 38.8379 18.4707 40.4757 18.4707Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3176 68.7363H45.0961C43.6882 68.7363 42.5469 69.879 42.5469 71.2887C42.5469 72.6983 43.6882 73.841 45.0961 73.841H58.3176C59.7255 73.841 60.8668 72.6983 60.8668 71.2887C60.8668 69.879 59.7255 68.7363 58.3176 68.7363Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.7891",
                y: "73.8242",
                width: "6.03885",
                height: "5.91267",
                rx: "2.95633",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.9727",
                y: "21.4121",
                width: "29.6575",
                height: "48.9139",
                rx: "1.98447",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.054 43.4716V42.5551C47.4179 42.5551 47.7129 42.2601 47.7129 41.8962V41.6584C47.7129 41.1956 47.3377 40.8203 46.8748 40.8203H42.5126C42.0498 40.8203 41.6745 41.1956 41.6745 41.6584V41.8962C41.6745 42.2601 41.9695 42.5551 42.3334 42.5551V43.4851C41.9719 43.6173 41.6601 43.8552 41.4399 44.1667C41.2197 44.4783 41.1016 44.8486 41.1016 45.2281V51.0003C41.1016 51.4632 41.4768 51.8384 41.9397 51.8384H47.4876C47.9505 51.8384 48.3257 51.4632 48.3257 51.0003V45.2289C48.3257 44.8423 48.2032 44.4653 47.9753 44.1504C47.7474 43.8354 47.4254 43.5981 47.054 43.4716Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.6328",
                y: "40.8301",
                width: "6.23904",
                height: "1.77561",
                rx: "0.52019",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.0345 57.829V56.9125C47.3984 56.9125 47.6934 56.6175 47.6934 56.2536V56.0159C47.6934 55.553 47.3182 55.1777 46.8553 55.1777H42.4931C42.0302 55.1777 41.655 55.553 41.655 56.0159V56.2536C41.655 56.6175 41.95 56.9125 42.3139 56.9125V57.8425C41.9523 57.9747 41.6405 58.2126 41.4204 58.5241C41.2002 58.8357 41.0821 59.206 41.082 59.5855V65.3577C41.082 65.8206 41.4573 66.1959 41.9202 66.1959H47.4681C47.9309 66.1959 48.3062 65.8206 48.3062 65.3577V59.5863C48.3062 59.1997 48.1837 58.8227 47.9558 58.5078C47.7279 58.1928 47.4058 57.9556 47.0345 57.829Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.625",
                y: "55.1855",
                width: "6.23904",
                height: "1.77561",
                rx: "0.52019",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "42.5078",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "56.9805",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "45.2305",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "59.6934",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3459_2825)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M55.804 30.111C55.804 30.111 55.804 30.1258 55.804 30.1406C55.804 30.2592 55.6135 32.748 52.3278 33.874V32.3184L54.3119 30.3036C54.4865 30.1258 54.4865 29.8443 54.2802 29.6666C54.0897 29.5036 53.7881 29.5036 53.5976 29.6962L52.3278 30.9999V29.6666C52.3278 29.6666 52.3278 29.6666 52.3278 29.6518C52.4865 29.311 53.2484 27.9777 55.1214 27.9777C55.1373 27.9777 55.1532 27.9777 55.169 27.9777C55.9151 28.8073 55.804 30.0962 55.804 30.111ZM51.3754 30.9999L50.0897 29.6962C49.9151 29.5184 49.6135 29.5036 49.423 29.6666C49.2325 29.8295 49.2167 30.1258 49.3913 30.3036L51.3754 32.3184V33.8592C48.0897 32.7332 47.9151 30.2295 47.8992 30.1258C47.8992 30.111 47.8992 30.111 47.8992 30.0962C47.8992 30.0814 47.7722 28.7925 48.5183 27.9629C48.5341 27.9629 48.55 27.9629 48.5817 27.9629C50.4706 27.9629 51.2167 29.311 51.3754 29.6369C51.3754 29.6369 51.3754 29.6369 51.3754 29.6518V30.9999ZM55.7405 27.2073C55.6611 27.1332 55.55 27.0888 55.4389 27.074C53.6452 26.9703 52.4706 27.8295 51.8516 28.6295C51.2325 27.8295 50.0738 26.9703 48.2643 27.074C48.1532 27.074 48.0421 27.1332 47.9627 27.2073C46.804 28.2888 46.931 30.0073 46.9468 30.1703C46.9468 30.2888 47.0262 31.1332 47.6135 32.111C48.169 33.0443 49.3437 34.274 51.677 34.8962C51.6929 34.8962 51.7087 34.8962 51.7087 34.911C51.7246 34.911 51.7246 34.911 51.7405 34.911C51.7564 34.911 51.7564 34.911 51.7722 34.911C51.7881 34.911 51.8198 34.911 51.8357 34.911C51.8516 34.911 51.8833 34.911 51.8992 34.911C51.9151 34.911 51.9151 34.911 51.931 34.911C51.9468 34.911 51.9468 34.911 51.9627 34.911C51.9786 34.911 51.9944 34.911 52.0103 34.8962C56.3437 33.7555 56.7246 30.4962 56.7405 30.1851C56.7564 30.0962 56.9151 28.3184 55.7405 27.2073Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3459_2825",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "10",
                        height: "8",
                        fill: "white",
                        transform: "translate(46.8516 27)"
                    })
                })
            })
        ]
    });
};

exports.OrderHistoryMobile = OrderHistoryMobile;
//# sourceMappingURL=OrderHistoryMobile.cjs.map
